import { render, staticRenderFns } from "./EmailDetail.vue?vue&type=template&id=abee58e6&scoped=true&"
import script from "./EmailDetail.vue?vue&type=script&lang=js&"
export * from "./EmailDetail.vue?vue&type=script&lang=js&"
import style0 from "./EmailDetail.vue?vue&type=style&index=0&id=abee58e6&prod&lang=scss&"
import style1 from "./EmailDetail.vue?vue&type=style&index=1&id=abee58e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abee58e6",
  null
  
)

export default component.exports